/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import ButtonLoading from "../../Button/ButtonLoading";
import EmailVerificationModal from "../../FormInfoModal/EmailVerificationModal";
import applicationFormStyle from "../applicationFormStyle";
import CostHintBox from "../../Serviceworld/Settlement/CostsHintBox/CostHintBox";
import PoaAgreementText from "../Common/PowerOfAttorney/PoaAgreementText";
import { useForm } from "../../../provider/Form/FormProvider";
import Signature from "../Common/Signature/Signature";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import { Box } from "@mui/material";

type PowerOfAttorneyProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

const PowerOfAttorney = ({ product, submitProps }: PowerOfAttorneyProps) => {
  const { handleSubmit } = useForm();

  return (
    <div>
      <Paper sx={applicationFormStyle.paper} elevation={4}>
        <Box component={"form"} sx={applicationFormStyle.applicationForm} id={"application-form"} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={applicationFormStyle.subheadline}>
            Vollmacht
          </Typography>
          <div>
            <p>
              Hiermit erteile ich den Legalbird Rechtsanwälten (Legalbird Rechtsanwälte Rechtsanwalts GmbH) in meiner Arbeitsrechtssache die Vollmacht zur
              außergerichtlichen Vertretung aller Art und die Prozessvollmacht für alle Verfahren in allen Instanzen.
            </p>
            <p>
              Die Vollmacht ermächtigt zu allen den Rechtsstreit betreffenden Prozesshandlungen, insbesondere zur Bestellung eines Vertreters, zur Beseitigung
              des Rechtsstreits durch Vergleich, Verzicht und Anerkenntnis, ferner zur Empfangnahme von Geldern und der vom Gegner, der Justizkasse oder anderen
              Stellen zu erstattenden Kosten.
            </p>
            <p>Die Befugnis umfasst auch die Übertragung der Vollmacht ganz oder teilweise auf andere.</p>
            <p>
              Mir ist bekannt, dass mit der Vollmacht eine Beauftragung und damit eine Anwaltsvergütung entsteht, deren Höhe abhängig vom Verfahrenswert ist,
              der vom Gericht festgesetzt wird. Diese Kosten werden gemäß der{" "}
              <Link target={"_blank"} to={"/agb-prozessfinanzierung"}>
                Legalbird Prozessfinanzierungs AGB
              </Link>{" "}
              übernommen.
            </p>
            <p>Die Bearbeitung meines Mandats erfolgt vorbehaltlich der Annahme durch die {product.lawFirm.name}.</p>
            <PoaAgreementText lawFirmName={product.lawFirm.name} hasNoWinNoFeeClause={true} />
          </div>
          <Signature product={product} person={product.client} />
          <Grid container justifyContent={"center"} alignItems={"baseline"}>
            <Grid item xs={12}>
              <ButtonLoading
                color="primary"
                variant="contained"
                type="submit"
                fullWidth={true}
                disabled={!product.client.signature}
                isLoading={submitProps.isLoading}
              >
                Vollmacht erteilen und beauftragen
              </ButtonLoading>
            </Grid>
            <Grid item />
            <Grid item xs={12}>
              <CostHintBox settlement={product} />
            </Grid>
          </Grid>
        </Box>
        <EmailVerificationModal />
      </Paper>
    </div>
  );
};
export default PowerOfAttorney;
